const localMessageIds = (message) => [
  message?.id,
  message?.uuid,
  message?.clientQueueId,
  message?.__stableKey,
  message?.__localKey,
].filter((value) => value != null && value !== "");

export const localMessageMatches = (message, targetId) => {
  if (targetId == null || targetId === "") return false;
  const target = String(targetId);
  return localMessageIds(message).some((value) => String(value) === target);
};

export const appendThreadMessage = (messages, message) => {
  const list = Array.isArray(messages) ? messages : [];
  if (!message) return list;
  return list.concat(message);
};

export const replaceThreadMessage = (messages, targetId, replacement) => {
  const list = Array.isArray(messages) ? messages : [];
  if (!replacement) return list;
  let replaced = false;
  const next = list.map((message) => {
    if (!localMessageMatches(message, targetId)) return message;
    replaced = true;
    return replacement;
  });
  return replaced ? next : list;
};

export const patchThreadMessage = (messages, targetId, patch = {}) => {
  const list = Array.isArray(messages) ? messages : [];
  let patched = false;
  const next = list.map((message) => {
    if (!localMessageMatches(message, targetId)) return message;
    patched = true;
    return {
      ...message,
      ...patch,
    };
  });
  return patched ? next : list;
};

export const removeThreadMessage = (messages, targetId) => {
  const list = Array.isArray(messages) ? messages : [];
  return list.filter((message) => !localMessageMatches(message, targetId));
};

export const moveThreadMessages = (messagesByThreadUuid, fromThreadUuid, toThreadUuid) => {
  if (!fromThreadUuid || !toThreadUuid || fromThreadUuid === toThreadUuid) {
    return messagesByThreadUuid || {};
  }
  if (!Object.prototype.hasOwnProperty.call(messagesByThreadUuid || {}, fromThreadUuid)) {
    return messagesByThreadUuid || {};
  }

  const next = { ...(messagesByThreadUuid || {}) };
  const fromMessages = Array.isArray(next[fromThreadUuid])
    ? next[fromThreadUuid]
    : [];
  next[toThreadUuid] = fromMessages;
  delete next[fromThreadUuid];
  return next;
};
